import React, { memo } from 'react'
import { Row, Col } from 'react-grid-system'
import { Modal } from '../..'

import KitItemSelector from './kitItemSelector'

const ManageKitModal = ({
   isModalOpen,
   handleClose,
   kitId,
   itemForm,
}: ManageKitModalProps) => (
   <Modal
      isModalVisible={isModalOpen}
      closeModal={handleClose}
      title="Manage Kit"
   >
      <Row gutterWidth={20}>
         <Col xs={12}>
            <KitItemSelector kitId={kitId} itemForm={itemForm} />
         </Col>
      </Row>
   </Modal>
)

export default memo(ManageKitModal)
